// src/pages/produtos/produtos/ProdutoFornecTab.js
import { useEffect, useState } from 'react';
import Input from '../../../components/input/Input';
import { useProdutoFornec } from '../../../contexts/produtos/ProdutoFornecContext';
import { useFornecedor } from '../../../contexts/pessoas/FornecedorContext';
import { IoIosAddCircle } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { useYesNo } from '../../../contexts/geral/YesNoContext';

const ProdutoFornecTab = ({ produto, setProduto, disableCampos }) => {
    const { produtoFornecs, fetchProdutoFornecs, addProdutoFornec, deleteProdutoFornec } = useProdutoFornec();
    const { showFornecedorSearch, showFornecedorCad } = useFornecedor();
    const [fornecTemp, setFornecTemp] = useState({ id: '', nome: '' });
    const [cProdFornecTemp, setCProdFornecTemp] = useState('');
    const { showYesNo } = useYesNo();

    // Carrega fornecedores do produto ao montar ou mudar produto.id
    useEffect(() => {
        setFornecTemp({ id: '', nome: '' });
        setCProdFornecTemp('');
        fetchProdutoFornecs(produto?.id || 0);
    }, [produto?.id]);

    const handleBuscarFornecedor = async () => {
        const fornecedorSel = await showFornecedorSearch();
        if (fornecedorSel) {
            setFornecTemp({ id: fornecedorSel.id, nome: fornecedorSel.pessoa?.nome || '' });
        }
    };

    const handleAddFornec = async () => {
        if (!fornecTemp.id) return;

        const novoFornec = {
            produtoId: produto.id,
            fornecedorId: fornecTemp.id,
            cProdFornec: cProdFornecTemp
        };

        await addProdutoFornec(novoFornec);
        setFornecTemp({ id: '', nome: '' });
        setCProdFornecTemp('');
        await fetchProdutoFornecs(produto.id);
    };

    const handleDeleteFornec = async (id) => {
        const resposta = await showYesNo("Deseja remover o fornecedor do produto?");
        if (resposta) {
            await deleteProdutoFornec(id);
        }
    };

    return (
        <div>
            <div className="input-group align-items-end mb-2">
                <Input
                    label="Fornecedor"
                    value={fornecTemp.id}
                    onChange={(e) => setFornecTemp({ ...fornecTemp, id: e.target.value })}
                    btnBuscar={handleBuscarFornecedor}
                    btnAdd={showFornecedorCad}
                    disabled={disableCampos || !produto?.id}
                    btnBuscarDisabled={disableCampos || !produto?.id}
                    btnAddDisabled={disableCampos || !produto?.id}
                    size={150}
                />
                <Input
                    value={fornecTemp.nome}
                    disabled
                    size={250}
                />
                <Input
                    label="Código Fornecedor"
                    value={cProdFornecTemp}
                    onChange={(e) => setCProdFornecTemp(e.target.value)}
                    disabled={disableCampos || !produto?.id}
                    size={150}
                />
                <button
                    className="btn btn-success ms-2"
                    type="button"
                    disabled={disableCampos || !produto?.id}
                    onClick={handleAddFornec}
                    title="Adicionar fornecedor"
                >
                    <IoIosAddCircle size={22} />
                </button>
            </div>

            {/* Grid de fornecedores */}
            <div className="table-responsive mt-2">
                <table className="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Fornecedor</th>
                            <th>Cód. Fornecedor</th>
                            <th style={{ width: 50 }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {produtoFornecs && produtoFornecs.length > 0 ? (
                            produtoFornecs.map(pf => (
                                <tr key={pf.id}>
                                    <td>{pf.id}</td>
                                    <td>{pf.fornecedorId}</td>
                                    <td>{pf.cProdFornec}</td>
                                    <td className="text-center">
                                        <button
                                            className="btn btn-sm btn-danger"
                                            type='button'
                                            onClick={() => handleDeleteFornec(pf.id)}
                                            disabled={disableCampos}
                                            title="Excluir fornecedor"
                                        >
                                            <MdDelete size={18} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">Nenhum fornecedor cadastrado.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProdutoFornecTab;
